import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import Layout, { DateInput } from "./Layout";
import { formatDate, getApiUrl, getTodayIso } from "./config";

function DailySummaryReport() {
  const today = getTodayIso();
  const [from, setFrom] = useState(today);
  const [to, setTo] = useState(today);
  const [rows, setRows] = useState([]);

  const fetchSummary = useCallback(async () => {
    try {
      const res = await axios.get(`${getApiUrl()}/reports/daily-summary`, { params: { from, to } });
      setRows(res.data || []);
    } catch (err) {
      console.error(err);
      const message =
        err?.response?.data?.message ||
        err?.response?.data?.sqlMessage ||
        err?.response?.data?.code ||
        "Failed to load summary";
      alert(message);
    }
  }, [from, to]);

  useEffect(() => {
    fetchSummary();
  }, [fetchSummary]);

  const handleExportPdf = () => {
    window.print();
  };

  return (
    <Layout>
      <div className="container mt-4">
        <h2>Day to Day Summary</h2>

        <div className="card p-4 mb-4 no-print">
          <div className="row g-3 align-items-end">
            <div className="col-md-3">
              <label className="form-label fw-bold">From</label>
              <DateInput value={from} onChange={setFrom} />
            </div>
            <div className="col-md-3">
              <label className="form-label fw-bold">To</label>
              <DateInput value={to} onChange={setTo} />
            </div>
            <div className="col-md-3 d-grid">
              <button type="button" className="btn btn-primary" onClick={fetchSummary}>
                Refresh
              </button>
            </div>
            <div className="col-md-3 d-grid">
              <button type="button" className="btn btn-outline-dark" onClick={handleExportPdf}>
                Export PDF
              </button>
            </div>
          </div>
        </div>

        <div className="table-responsive">
          <table className="table table-striped">
            <thead>
              <tr>
                <th>Date</th>
                <th>Sales</th>
                <th>Purchases</th>
                <th>Receipts</th>
                <th>Vouchers</th>
                <th>Expenses</th>
                <th>Cash In</th>
                <th>Cash Out</th>
                <th>Net Cash</th>
                <th>UPI In</th>
                <th>UPI Out</th>
                <th>Net UPI</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.date}>
                  <td>{formatDate(r.date)}</td>
                  <td>₹ {(r.sale_total || 0).toFixed(2)}</td>
                  <td>₹ {(r.purchase_total || 0).toFixed(2)}</td>
                  <td>₹ {(r.receipt_total || 0).toFixed(2)}</td>
                  <td>₹ {(r.voucher_total || 0).toFixed(2)}</td>
                  <td>₹ {(r.expense_total || 0).toFixed(2)}</td>
                  <td className="text-success">₹ {(r.cash_in || 0).toFixed(2)}</td>
                  <td className="text-danger">₹ {(r.cash_out || 0).toFixed(2)}</td>
                  <td className="fw-bold">₹ {(r.net_cash || 0).toFixed(2)}</td>
                  <td className="text-success">₹ {(r.upi_in || 0).toFixed(2)}</td>
                  <td className="text-danger">₹ {(r.upi_out || 0).toFixed(2)}</td>
                  <td className="fw-bold">₹ {(r.net_upi || 0).toFixed(2)}</td>
                </tr>
              ))}
              {rows.length === 0 && (
                <tr>
                  <td colSpan="12" className="text-center">
                    No data
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  );
}

export default DailySummaryReport;
